module.exports = __webpack_public_path__ + "static/media/sdmt4.32fd78dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt4.svg
// module id = 344
// module chunks = 0